import { render, staticRenderFns } from "./DocumentsDetails.vue?vue&type=template&id=ae1240da"
import script from "./DocumentsDetails.vue?vue&type=script&lang=js"
export * from "./DocumentsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports